import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import httpRequest from "src/helpers/httpRequest";
import AddCartComponent from "./AddCartComponent";
import biomarkerIcon from "src/assets/images/biomarker-ye.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus, faStar } from "@fortawesome/free-solid-svg-icons";
import BoxWrapper from "src/Components/WebsiteComponents/BoxWrapper";
import FavoriteCoponent from "src/Components/GlobalComponents/FavoriteCoponent";
import ShareComponent from "src/Components/GlobalComponents/ShareComponent";
import { capitalize, Skeleton } from "@mui/material";
import HowManytDealOFF from "src/Components/GlobalComponents/HowManytDealOFF";
import { CURRENCY } from "src/lib/constans";
import { removeAllDisLike } from "src/Store/disLike";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/Store/store";


interface IObj {
  _id: string;
  name: string;
  description: string;
  prescriptionRequired: boolean;
  regularPrice: number;
  salePrice: number;
  saleStartDate: string;
  saleEndDate: string;
  instructions: { instructionDetail: string; _id: string }[];
  image: string;
  status: boolean;
  isLiked: boolean;
  createdAt: string;
  updatedAt: string;
  __v: number;
  tests: { id: string; name: string }[];
  noOfTests: number;
  faq: { question: string; answer: string; _id: string }[];
  [key: string]: any;
}

const DPackageDetails: React.FC<{
  id: string;
  setName?: (val: string) => void;
}> = ({ id = "", setName = () => {} }) => {
  const [faqsOpen, setFaqsOpen] = useState<string[]>([]);
  const [isLoader, setIsLoader] = useState<boolean>(true);
  const [item, setItem] = useState<IObj | null>(null);

  const { packageDisLike } = useSelector((state: RootState) => state.disLike);
  const dispatch = useDispatch<AppDispatch>();

  const handleToogle = (id: string) => {
    setFaqsOpen((prev) =>
      prev?.includes(id) ? prev?.filter((v) => v !== id) : [...prev, id]
    );
  };

  const fetch = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IObj>({
      path: `/diagnostic-package/single-customer/${id}`,
    });
    if (res) {
      setItem(res || null);
      setName(res?.name || "");
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    if (id) {
      fetch();
    }
  }, [id]);

  useEffect(() => {
    if (packageDisLike.length > 0) {
      let updatedStatusData = {
        ...item,
        isLiked: packageDisLike.find((i) => i === item?._id)
          ? false
          : item?.isLiked,
      }
      setItem(updatedStatusData as IObj);
      dispatch(removeAllDisLike("packageDisLike"));
    }
  }, [packageDisLike]);
  return (
    <>
      <>
        <div className="grid grid-cols-1 md:grid-cols-[4fr,8fr] gap-3">
          {isLoader ? (
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              className="rounded-md xl:rounded-lg aspect-square"
            />
          ) : (
            <div className="w-full relative border border-gray-300 flex items-center justify-center rounded-lg overflow-hidden aspect-square">
              <HowManytDealOFF
                salePrice={item?.salePrice || 0}
                regularPrice={item?.regularPrice || 0}
                detailsUI={true}
              />
              <div className="absolute top-3 right-3 flex items-center gap-2 flex-col">
                <FavoriteCoponent
                  id={item?._id || "dummy"}
                  liked={item?.isLiked}
                  onLikeProduct={(id, isLiked) => {
                    setItem({
                      ...item,
                      isLiked: isLiked,
                    } as IObj);
                  }}
                  category="package"
                />
                <ShareComponent
                  shareText={`${capitalize(
                    item?.brandName || ""
                  )} - Product Id is ${item?._id}`}
                  shareTitle={`${capitalize(item?.productName || "")}`}
                />
              </div>
              <img
                src={`${item?.image}`}
                alt={item?.name || ""}
                className="w-full h-full object-cover"
              />
            </div>
          )}
          <div className="flex flex-col gap-10">
            <div className="flex flex-col gap-5">
              <div className="flex flex-row justify-between items-start">
                {isLoader ? (
                  <div className="w-full">
                    <Skeleton
                      variant="text"
                      width={"50%"}
                      height={"2vw"}
                      className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
                    />
                    <Skeleton
                      variant="text"
                      width={"45%"}
                      height={"2vw"}
                      className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
                    />
                  </div>
                ) : (
                  <p
                    title={item?.name}
                    className="font-Lexend-Regular break-all product-detail-name line-clamp-2 leading-tight diagostic-product-detail-title text-[#393939] font-size-25px"
                  >
                    {item?.name}
                  </p>
                )}
              </div>
              <div className="flex gap-2 items-center mb-3">
                <div className="text-yellow-400 text-[15px] 2xl:text-[20px] flex flex-row reviewstars items-center">
                  {isLoader ? (
                    <Skeleton
                      variant="text"
                      width={"20%"}
                      height={"1.8vw"}
                      className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
                    />
                  ) : (
                    [1, 2, 3, 4, 5].map((v) => (
                      <FontAwesomeIcon
                        key={v}
                        className={
                          (item?.averageRating || 0) >= v
                            ? "text-[#facc15] mr-0.5"
                            : "text-[#b7b6b1] mr-0.5"
                        }
                        icon={faStar}
                      />
                    ))
                  )}
                  {isLoader ? (
                    <Skeleton
                      variant="text"
                      width={"20%"}
                      height={"1.8vw"}
                      className="rounded-md ml-2 min-w-[200px] max-w-[90%] min-h-5"
                    />
                  ) : (
                    <span className="text-[#707070] font-Poppins-Regular font-size-16px -mb-1 ml-2">
                      {item?.averageRating
                        ? item?.averageRating.toFixed(1)
                        : "0.0"}{" "}
                      - {(item?.ratingsCount || 0).toString().padStart(2, "0")}{" "}
                      Reviews
                    </span>
                  )}
                </div>
              </div>
              <div className="diagostic-product-detail-activity">
                <div className="diagostic-product-detail-include">
                  {isLoader ? (
                    <Skeleton
                      variant="rectangular"
                      width={"1.5vw"}
                      height={"1.5vw"}
                      className="rounded-md aspect-square min-w-[25px] min-h-[25px]"
                    />
                  ) : (
                    <img src={biomarkerIcon} alt="" />
                  )}
                  {isLoader ? (
                    <Skeleton
                      variant="text"
                      width={"50%"}
                      height={"1.8vw"}
                      className="rounded-md min-w-[100px] max-w-[90%] min-h-5"
                    />
                  ) : (
                    <span className="text-[#707070] font-size-15px font-Poppins-Regular">{`${
                      item?.noOfTests || ""
                    } Tests`}</span>
                  )}
                </div>
              </div>
            </div>
            {isLoader ? (
              <div className="flex flex-col">
                <Skeleton
                  variant="text"
                  width={"100%"}
                  height={"1.6vw"}
                  className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
                />
                <Skeleton
                  variant="text"
                  width={"100%"}
                  height={"1.6vw"}
                  className="rounded-md min-w-[200px] max-w-[70%] min-h-5"
                />
              </div>
            ) : (
              <p
                title={item?.description}
                className="font-Lexend-Regular line-clamp-2 lg:line-clamp-3 2xl:line-clamp-4 text-[#707070] font-size-15px"
              >
                {item?.description}
              </p>
            )}
            <div className="flex flex-col gap-4 w-fit">
              {isLoader ? (
                <Skeleton
                  variant="text"
                  width={"50%"}
                  height={"2vw"}
                  className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
                />
              ) : (
                <div className="flex gap-4 items-center w-fit">
                  <span className="text-[#202020] font-Poppins-SemiBold  font-size-26px">
                    {CURRENCY} {item?.salePrice || item?.regularPrice}
                  </span>
                  {item?.salePrice != null && item?.salePrice > 0 && (
                    <span className="text-[#434343] line-through font-Poppins-Regular font-size-19px">
                      {CURRENCY} {item?.regularPrice || ""}
                    </span>
                  )}
                </div>
              )}
              {isLoader ? (
                <Skeleton
                  variant="rectangular"
                  width={"20%"}
                  height={"2.4vw"}
                  className="rounded-full min-w-[120px] max-w-[90%] min-h-5"
                />
              ) : (
                <AddCartComponent
                  textBtn={true}
                  productId={item?._id || ""}
                  type="diagnostic"
                  prescriptionRequired={item?.prescriptionRequired || false}
                  quantity={1}
                  itemType="package"
                  btnStyle={{
                    width: "fit-content",
                  }}
                />
              )}
            </div>
          </div>
        </div>
        <BoxWrapper
          loading={isLoader}
          title="Tests included"
          productDetailBoxDesign
        >
          {isLoader ? (
            <Skeleton
              variant="text"
              width={"50%"}
              height={"1.8vw"}
              className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
            />
          ) : (
            item?.tests?.map((v) => (
              <div
                key={v?.id}
                className="product-detail-biomarker-included-test-inst-inner"
              >
                <strong></strong>
                <p className="text-[#707070] font-size-18px font-Lexend-Regular">
                  {v?.name || ""}
                </p>
              </div>
            ))
          )}
        </BoxWrapper>
        <BoxWrapper
          loading={isLoader}
          title="Test Instructions"
          productDetailBoxDesign
        >
          {isLoader ? (
            <div className="flex flex-col">
              <Skeleton
                variant="text"
                width={"50%"}
                height={"1.8vw"}
                className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
              />
              <Skeleton
                variant="text"
                width={"50%"}
                height={"1.8vw"}
                className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
              />
            </div>
          ) : (
            item?.instructions?.map((v) => (
              <div
                key={v?._id}
                className="product-detail-biomarker-included-test-inst-inner"
              >
                <strong></strong>
                <p className="text-[#707070] font-size-18px font-Lexend-Regular">
                  {v?.instructionDetail || ""}
                </p>
              </div>
            ))
          )}
        </BoxWrapper>
        <BoxWrapper
          loading={isLoader}
          title="FAQs"
          titleClass="!pt-0 !px-0 xl:px-0"
          className="p-2 xl:p-4"
          productDetailBoxDesign
          viewContainerClass="!p-0 !xl:p-0"
          darkTitleBorder
        >
          {isLoader ? (
            <Skeleton
              variant="text"
              width={"50%"}
              height={"1.8vw"}
              className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
            />
          ) : (
            item?.faq?.map((v, index) => (
              <div
                key={v?._id}
                className="product-detail-faqs-main"
                onClick={() => handleToogle(v?._id)}
                id={`diagnostic-package-details-faq-${index + 1}`}
              >
                <div className="product-detail-faqs">
                  <span className="font-size-20px font-Poppins-Regular text-[#707070]">
                    {v?.question}
                  </span>
                  <FontAwesomeIcon
                    className="font-size-20px text-[#707070]"
                    icon={faqsOpen?.includes(v?._id) ? faMinus : faPlus}
                  />
                </div>
                {faqsOpen?.includes(v?._id) ? (
                  <div className="faq-content">
                    <p className="text-[#B8B6B6] font-size-18px font-Poppins-Regular">
                      {v?.answer}
                    </p>
                  </div>
                ) : null}
              </div>
            ))
          )}
        </BoxWrapper>
      </>
    </>
  );
};

export default DPackageDetails;
